import { FC, useRef } from 'react';
import { LeaguesPageHero } from '@/components/LeaguesPageHero/LeaguesPageHero';
import { JoinLeagueBanner } from '@/components/JoinLeagueBanner/JoinLeagueBanner';
import { LeagueStack } from '@/components/LeagueStack/LeagueStack';
import { useLeaguesStore } from '@/stores/LeaguesStore';
import { useNavigate } from 'react-router';
import { ContentAdSlot } from '@/ads';
import { trackFantasyEvent } from '@/analytics/fantasyEventTracking';

const MyLeagues: FC = () => {
  const joinBannerRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { leagues, loading } = useLeaguesStore();

  const totalLeagues = leagues.length + 1; // +1 for the overall leaderboard
  const subtitle = loading
    ? undefined
    : totalLeagues === 1
      ? 'You have 1 active league'
      : `You have ${totalLeagues} active leagues`;

  return (
    <div className="components light flex flex-col">
      <LeaguesPageHero
        title="LEAGUES"
        subtitle={subtitle}
        onJoinLeague={() => {
          trackFantasyEvent('leagueLink', { link_name: 'Join League' });
          navigate('/leagues/join');
        }}
        onCreateLeague={() => {
          trackFantasyEvent('leagueLink', { link_name: 'Create League' });
          navigate('/leagues/create');
        }}
      />
      <div className="flex flex-col gap-[--padding-3xl] sm:gap-[--padding-4xl] p-[--padding-md] sm:p-0 sm:pt-[--padding-3xl] max-w-[846px] mx-auto w-full">
        <LeagueStack />
        <div ref={joinBannerRef}>
          <JoinLeagueBanner />
        </div>
      </div>
      <ContentAdSlot id="ad-boa-leaderboard" />
    </div>
  );
};

export default MyLeagues;
